<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-multicolor">
		<path d="M41.5978 12.0038C39.7546 8.39005 36.9481 5.35634 33.4885 3.23793C30.0288 1.11953 26.0509 -0.00106503 21.9942 7.5927e-07L22 22L41.5978 12.0038Z" fill="#F19A18"/>
		<path d="M22 44C24.8891 44 27.7499 43.4309 30.419 42.3253C33.0882 41.2197 35.5135 39.5992 37.5564 37.5563C39.5992 35.5135 41.2198 33.0882 42.3254 30.419C43.431 27.7499 44 24.8891 44 22L22 22L22 44Z" fill="#009800"/>
		<path d="M39.7319 35.0223C42.4674 31.2974 43.9604 26.8058 43.9992 22.1846C44.038 17.5634 42.6205 13.0473 39.9479 9.27709L22 22L39.7319 35.0223Z" fill="#EBEB10"/>
		<path d="M22 44C25.7951 44 29.5256 43.0183 32.8291 41.1502C36.1326 39.2821 38.8967 36.5913 40.8527 33.3391L22 22L22 44Z" fill="#009800"/>
		<path d="M2.40217 31.9962C4.24541 35.61 7.05194 38.6437 10.5115 40.7621C13.9712 42.8805 17.9491 44.0011 22.0058 44L22 22L2.40217 31.9962Z" fill="#33ACC9"/>
		<path d="M4.26811 8.97775C1.53261 12.7026 0.0395631 17.1942 0.000791411 21.8154C-0.0379803 26.4367 1.3795 30.9527 4.05211 34.7229L22 22L4.26811 8.97775Z" fill="#7B2A7B"/>
		<path d="M22 6.0194e-06C18.2049 6.95518e-06 14.4744 0.981742 11.1709 2.84981C7.86739 4.71787 5.10332 7.40873 3.14728 10.6609L22 22L22 6.0194e-06Z" fill="#DA4A4A"/>
	</svg>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
.icon-multicolor{

}
</style>